/**
 * Per-page SEO meta v jednom volání. `useSeoMeta` NEzrcadlí title/description do
 * og:/twitter: tagů automaticky, takže to dělá tenhle wrapper — jeden zdroj
 * pravdy pro title, description, og:title/description/image i twitter varianty.
 *
 * `title`/`description` předávej jako getter, ať zůstanou reaktivní, než doběhne
 * dotaz na entitu. Prázdné hodnoty se mapují na `undefined`, aby se tag vůbec
 * nevykreslil (prázdný meta tag je horší než žádný). `image` jde přes
 * useOgImage() — absolutní URL + fallback na výchozí sdílecí obrázek webu.
 *
 * Pozn.: do `<title>` se přes globální `titleTemplate` (app.vue) doplní
 * prefix/suffix ze SEO nastavení; og:title zůstává bez template — samotný název
 * stránky je pro sdílení lepší (og:site_name nese značku).
 */
export function usePageSeo(opts: {
  title: MaybeRefOrGetter<string | null | undefined>
  description?: MaybeRefOrGetter<string | null | undefined>
  /** Cesta/URL obrázku entity (typicky `...paths.thumbs.og`). */
  image?: MaybeRefOrGetter<string | null | undefined>
  /**
   * Stránky, které nemají být v indexu (členský obsah, utility stránky).
   * Getter pro podmíněné případy (free vs. placený projekt); `undefined`
   * (např. entita ještě nenačtená) tag vůbec nevykreslí.
   */
  noindex?: MaybeRefOrGetter<boolean | undefined>
}) {
  const title = computed(() => toValue(opts.title) || undefined)
  const description = computed(() => toValue(opts.description) || undefined)

  useSeoMeta({
    title,
    description,
    ogTitle: title,
    ogDescription: description,
    ogImage: useOgImage(opts.image),
    twitterTitle: title,
    twitterDescription: description,
    robots: computed(() => (toValue(opts.noindex) ? 'noindex' : undefined)),
  })
}
